import { ENewReviewStep } from '../../types/newReview';

export const REVIEWS_COUNT_PLURAL: [string, string, string] = ['отзыв', 'отзыва', 'отзывов'];
export const ANSWERS_COUNT_PLURAL: [string, string, string] = ['ответ', 'ответа', 'ответов'];
export const QUESTIONS_COUNT_PLURAL: [string, string, string] = ['вопрос', 'вопроса', 'вопросов'];

export const REVIEWS_VALUES: number[] = [1, 2, 3, 4, 5];

export const REVIEWS_PROS_AND_CONS_MAX_LENGTH = 3000;
export const ANSWER_MAX_LENGTH = 3000;

export const NEW_REVIEW_NOT_CONTENT_STEPS = [ENewReviewStep.Success, ENewReviewStep.Error];
